import { useDispatch } from "react-redux";
import { useState, useEffect } from 'react';
import { fetchAllTickets } from '../../../slices/TicketSlice';
import "./StudentTicketDashboard.scss";
import CreateTicketButton from './CreateTicketButton/CreateTicketButton';
import TicketList from './TicketList/TicketList';
import TicketPopup from './TicketPopup/TicketPopup';

export default function StudentTicketDashboard() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllTickets());
  }, [dispatch]);

  useEffect(() => {
    document.body.classList.add("student-dashboard-active");
    return () => document.body.classList.remove("student-dashboard-active");
  }, []);

  const togglePopup = () => setIsPopupOpen((open) => !open);

  return (
    <main
      className="student-ticket-dashboard-container"
      data-testid="StudentTicketDashboard"
    >
      <section className="ticket-list-container" data-testid="ticket-list-container">
        <div className="ticket-dashboard-heading">
          <h1>My Tickets:</h1>
          <div className="create-ticket-button-slot">
            <CreateTicketButton
              onOpen={togglePopup}
              data-testid="create-ticket-button"
            />
          </div>
        </div>

        <div className="student-ticket-list-shell" data-testid="ticket-list">
          <TicketList width="100%" user="student" />
        </div>
      </section>

      {isPopupOpen && (
        <TicketPopup onClose={togglePopup} data-testid="ticket-popup" />
      )}
    </main>
  );
}
